<script>
import NextSection from "@/components/common/NextSection.vue";
import anims from "@/mixins/anims";
import Form from "@/components/common/Form";

export default {
  name: "projectNorway",

  metaInfo: {
    title: "Norway",
    // meta: [
    //   { name: 'description', content: ""}
    // ]
  },

  components: {
    NextSection,
    Form,
  },

  mixins: [anims],
};
</script>

<template>
  <div>
    <div class="full-section anim anim-opacity-1" data-anim>
      <div class="full-section__container">
        <div class="row" data-row="start">
          <div class="card card--left" data-anim>
            <img
              src="@/assets/img/projects/norway/norway-1.jpg"
              alt=""
              class="anim anim-scene-1 anim-scene-1-mob"
            />
          </div>
          <div class="card card--right" data-anim>
            <h2 class="title anim anim-scene-2">Norway</h2>
            <div class="city anim anim-scene-3">CHLOE / МОСКВА</div>
          </div>
        </div>
      </div>
    </div>

    <div class="grid">
      <div class="row" data-row="1">
        <div class="card card--left" data-anim>
          <img
            src="@/assets/img/projects/norway/norway-2.jpg"
            alt=""
            class="anim anim-scene-1"
          />
        </div>
        <div class="card card--right" data-anim>
          <img
            src="@/assets/img/projects/norway/norway-3.jpg"
            alt=""
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>
      <div class="row" data-row="2">
        <div class="card card--left" data-anim>
          <img
            src="@/assets/img/projects/norway/norway-4.jpg"
            alt=""
            class="anim anim-scene-1"
          />
        </div>
        <div class="card card--right" data-anim>
          <img
            src="@/assets/img/projects/norway/norway-5.jpg"
            alt=""
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>
      <div class="row" data-row="3">
        <div class="card card--right" data-anim>
          <img
            src="@/assets/img/projects/norway/norway-6.jpg"
            alt=""
            class="anim anim-scene-2 anim-scene-1-mob"
          />
        </div>
      </div>
    </div>

    <Form />

    <NextSection
      title="Chernyahovskogo"
      link="/projects/chernyahovskogo_19"
      image="projects/norway/next.jpg"
      imageMob="projects/norway/next_mob.jpg"
    />

    <div
      xmlns:v="http://rdf.data-vocabulary.org/#"
      class="breadcrumbs"
      style="font-size: 0"
    >
      <span typeof="v:Breadcrumb">
        <a href="https://lithiumhome.ru" rel="v:url" property="v:title"
          >https://lithiumhome.ru/</a
        >
        ›
      </span>
      <span typeof="v:Breadcrumb">
        <a
          href="https://lithiumhome.ru/projects/capital"
          rel="v:url"
          property="v:title"
          >Capital</a
        >
        ›
      </span>
      <span typeof="v:Breadcrumb">Текущая категория</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.full-section {
  padding: vw(60) vw(0);
  background-color: #f2f2f2;

  &__subtitle {
    letter-spacing: 0.06em;
  }
  &__title {
    letter-spacing: -0.02em;
  }
}

.grid {
  padding: vw(132) vw(126) vw(0);
  background-color: #f2f2f2;
  overflow: hidden;
}

.row {
  display: flex;
  align-items: center;
  margin-bottom: vw(200);

  &[data-row="start"] {
    margin-bottom: 0;
    .title {
      font-weight: 400;
      font-size: vw(22);
      line-height: vw(30);
      color: #2e2e2e;
      margin-bottom: vw(11);
    }
    .city {
      font-size: vw(14);
      line-height: vw(14);
      letter-spacing: 0.08em;
      text-transform: uppercase;
      color: #666;
      margin-bottom: vw(35);
    }
    .text {
      font-family: "Helvetica";
      font-weight: 300;
      font-size: vw(18);
      line-height: vw(31);
      color: #666;
    }
    .card {
      &--left {
        width: vw(531);
        margin-left: vw(217);
        margin-right: vw(288);
      }
      &--right {
        width: vw(531);
      }
    }
  }

  &[data-row="1"] {
    .card {
      &--left {
        width: vw(784);
        margin-right: vw(253);
      }
      &--right {
        width: vw(531);
      }
    }
  }

  &[data-row="2"] {
    .card {
      &--left {
        width: vw(693);
        margin-right: vw(162);
        margin-left: vw(91);
      }
      &--right {
        width: vw(531);
      }
    }
  }

  &[data-row="3"] {
    .card {
      &--right {
        width: vw(1386);
        margin-left: vw(91);
      }
    }
  }
}

@include max-width(mobile) {
  .full-section {
    overflow: hidden;
    min-height: auto;
    padding: vwm(40) vwm(18);
    &#start {
      opacity: 0;
      transition: opacity 0.7s ease 0.5s;
    }
    &#start.isEntered {
      opacity: 1;
    }
  }
  .full-section {
    &__container {
      background-position: top;
      min-height: vw-m(430);
    }
  }

  .grid {
    padding: vwm(6) vwm(18) vw-m(90);
    background-color: #f2f2f2;
  }
  .row {
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: vwm(46) !important;
    .card {
      width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      & + .card {
        margin-top: vwm(46);
      }
    }
    &[data-row="start"] {
      max-width: 100%;
      .title {
        font-size: vwm(15);
        line-height: vwm(15);
        margin-bottom: vwm(10);
      }
      .city {
        font-size: vwm(12);
        line-height: vwm(12);
      }
    }
  }
}
</style>
